import React, { useEffect, useRef } from 'react'
import { manualCopyHint, selectText } from './clipboard'

// What a Copy button shows when the browser wouldn't copy and the text isn't
// on screen to select (a permalink, a code shown as digits): the text,
// selected as it appears, and the shortcut to press.
export const ManualCopy = ({ text, className }) => {
  const ref = useRef(null)
  useEffect(() => { selectText(ref) }, [text])
  return (
    <p className={['sw-hint m-0', className].filter(Boolean).join(' ')} role="status">
      <span className="sw-mono" ref={ref}>{text}</span> {`${manualCopyHint()}.`}
    </p>
  )
}
